<div class="mat-table">
    <div class="table_principal">
        <table mat-table  matSort [dataSource]="matDataSourceBC" (matSortChange)="trieTab($event)" matSortActive="dCreation"
            matSortDirection="desc" matSortDisableClear>
            <caption>Liste des Bcs</caption>
            <ng-container #table matColumnDef="selectRow" *ngIf="ifCreateBp === true">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()"
                        [disabled]="selectedBcs.length === 0">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="align-cell">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectRow(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)"
                        [disabled]="isRowDisabled(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="selectRow" *ngIf="ifListAValide === true">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectRow(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)" [disableRipple]="true">
                    </mat-checkbox>
                </td>
            </ng-container> 

            <ng-container matColumnDef="typeBC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let element" class="centrer padding-0">
                    <div *ngIf="element.type == definitionTypeBC.BCStandard" matTooltip="{{definitionNamesBC.getNameFromType(element.type)}}"> <mat-icon>shopping_cart</mat-icon></div>
                    <div *ngIf="element.type == definitionTypeBC.BCEnveloppe" matTooltip="{{definitionNamesBC.getNameFromType(element.type)}}"> <mat-icon>mail_outline</mat-icon></div>
                </td>
            </ng-container>

            <ng-container matColumnDef="societe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Société </th>
                <td mat-cell *matCellDef="let element" class="centrer padding-0">
                    <div *ngIf="element.societe" matTooltip="{{element.societe.libelle}}"> {{element.societe.code}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="chantier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Code Chantier </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.chantier}}</td>
            </ng-container>

            <ng-container matColumnDef="libelle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Libellé du BC </th>
                <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.libelle" class="with-padding-left"> 
                        {{ width > 1536 ? (element.libelle.length < 40 ? element.libelle : element.libelle.slice(0,37) + '...'): (element.libelle.length < 20 ? element.libelle : element.libelle.slice(0,17) + '...')}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.status}} </td>
            </ng-container>
            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > N° BC </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.fValide === 2 ? element.code : "Cxxxxxxxxxx"}} </td>
            </ng-container>
            <ng-container matColumnDef="dBc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.dBc | date:'dd/MM/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="libelleFourn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fournisseur </th>
                <td mat-cell *matCellDef="let element">
                    <div class="with-padding-left" *ngIf="element.codeFourn && element.libelleFourn" matTooltip="{{element.codeFourn}} ">
                        {{ width > 1536 ? (element.libelleFourn.length < 40 ? element.libelleFourn : element.libelleFourn.slice(0,37) + '...'): (element.libelleFourn.length < 20 ? element.libelleFourn : element.libelleFourn.slice(0,17) + '...')}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="ht">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant HT </th>
                <td mat-cell *matCellDef="let element" class="allign-right">
                    <div class="with-padding-right">
                        {{element.ht | currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="dLivraison">
                <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Date de livraison prévisionnelle / Date de fin de validité" > D livraison / <br> fin validité</th>
                <td mat-cell *matCellDef="let element" class="centrer">
                    {{element.type === definitionTypeBC.BCEnveloppe ? (element.dFinValid | date:'dd/MM/yyyy') : element.dLivraison | date:'dd/MM/yyyy'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="annule">
                <th mat-header-cell *matHeaderCellDef  matTooltip="Annulé"> A </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon red" matTooltip="Totalement annulé" *ngIf="element.fAnnule === 2">cancel
                    </mat-icon>
                    <mat-icon class="align-icon grey" matTooltip="Partiellement annulé" *ngIf="element.fAnnule === 1">cancel
                    </mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="valide">
                <th mat-header-cell *matHeaderCellDef matTooltip="Validé"> V </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon green" matTooltip="Totalement validé" *ngIf="element.fValide === 2">check_circle
                    </mat-icon>
                    <mat-icon class="align-icon grey" matTooltip="En cours de validation" *ngIf="element.fValide === 1">check_circle
                    </mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="livre">
                <th mat-header-cell *matHeaderCellDef matTooltip="Livré"> L </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon green" matTooltip="Plus de livraison en attente" *ngIf="element.fLivre === 2">check_circle
                    </mat-icon>
                    <mat-icon class="align-icon grey" matTooltip="Livraison partielle" *ngIf="element.fLivre === 1">check_circle
                    </mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="provis">
                <th mat-header-cell *matHeaderCellDef  matTooltip="Provisionné"> P </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon green" matTooltip="Plus de livraison en attente et elles ont toutes été envoyées à SAGE" *ngIf="element.fProvis === 2">check_circle</mat-icon>
                    <mat-icon class="align-icon grey" matTooltip="Provision partielle" *ngIf="element.fProvis === 1">check_circle</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="dProvis">
                <th mat-header-cell *matHeaderCellDef matTooltip="Déprovisionné"> D </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon green" matTooltip="Plus de livraison en attente et elles ont toutes été déprovisionnées et envoyées à SAGE" *ngIf="element.fDeprovis === 2">check_circle</mat-icon>
                    <mat-icon class="align-icon grey" matTooltip="Déprovision partielle" *ngIf="element.fDeprovis === 1" >check_circle</mat-icon>
                </td>
            </ng-container>  
            <ng-container matColumnDef="bloque">
                <th mat-header-cell *matHeaderCellDef matTooltip="Blocage dans le circuit de validation ou présence d'un litige"> B </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <mat-icon class="align-icon red" matTooltip="Bloqué dans le circuit de validation ou BC totalement en litige" *ngIf="(element.bBloque) || (element.fLitige === 2 && !element.bBloque)">  cancel</mat-icon>
                    <mat-icon class="align-icon grey" matTooltip="BC contenant des litiges" *ngIf="element.fLitige === 1 && !element.bBloque" class="align-icon grey">cancel</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="bp">
                <th mat-header-cell *matHeaderCellDef matTooltip="Facturé"> F </th>
                <td mat-cell *matCellDef="let element" class="align-cell">
                    <div *ngIf="element.fHasBp">
                        <mat-icon class="align-icon green"  matTooltip="Plus de livraison en attente et elles ont toutes été facturées" *ngIf="element.fHasBp === 2">check_circle</mat-icon>
                        <mat-icon class="align-icon grey"  matTooltip="Facturation partielle" *ngIf="element.fHasBp=== 1">check_circle</mat-icon>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="libelleCa1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> CA1 </th>
                <td mat-cell *matCellDef="let element" >
                    <div class="with-padding-left" *ngIf="element.libelleCa1" matTooltip="{{element.codeCa1}} "> 
                        {{ width > 1536 ? element.libelleCa1.length < 40 ? element.libelleCa1 : element.libelleCa1.slice(0,37) + '...' : element.libelleCa1.length < 20 ? element.libelleCa1 : element.libelleCa1.slice(0,17) + '...'}} </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="trigrammeCreateur">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Créateur </th>
                <td mat-cell *matCellDef="let element" matTooltip="{{element.nomCompletCreateur}}" class="centrer">
                    {{element.trigrammeCreateur}}
                </td>
            </ng-container>
            <ng-container matColumnDef="BCAmont">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> BC Amont </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.bcAmont}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsBC; sticky: true"></tr>
            <div *ngIf="!ifListAValide">
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBC;" (click)="editBC(row); selectRow(row);"
                    [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}">
                </tr>
            </div>
            <div *ngIf="ifListAValide">
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBC;" (click)="editBC(row);"
                    [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}">
                </tr>
            </div>
        </table>
        <div class="footer">
            <mat-paginator #paginator [length]="this.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                [pageSizeOptions]="[25, 50, 150]" (page)="changePage($event)">
            </mat-paginator>
        </div>
    </div>
</div>